<template>
    <header class="border-b bg-white shadow-sm w-full top-0 z-[50] sm:fixed absolute xl:max-w-[390px] xl:mr-[398px] xl:translate-x-1/2">
        <div class="px-5 py-3 flex items-center justify-between border-b border-t">
            <div class="flex items-center">
                <div class="px-[18px] flex flex-col">
                    <span class="text-[16px] font-bold">Notificações</span>
                    <span class="text-[12px] font-medium text-[#2E59FF] cursor-pointer hover:underline" @click="markAllRead">Marcar todas as notificações como lidas</span>
                </div>
            </div>
            <Icon @click="$emit('close')" name="SetaDireita" class="text-primary"/>
        </div>
        <section class="flex flex-col px-5 py-4 gap-y-5 my-5 overflow-y-scroll max-h-[80vh] noscroll" name="notifications">
            <Notification v-for="(data, key) in data"
                :key="key" :title="data.notification.title"
                :notificationId="data.notification.id"
                :dataCreated="data.notification.startDate || data.notification.createdAt"
                :text="data.notification.text"
                :hyperlink="data.notification.hyperlink"
                :asRead="data.read"
                @foiLido="data.read = true"
            />
        </section>
    </header>
</template>
<script>
import Icon from '@/Components/UI/Icons/Icon.vue'
import Notification from '@/Components/Notification.vue'
import NavLink from '@/Components/NavLink.vue'

export default {
    components: {
        Icon,
        Notification,
        NavLink
    },
    props: {
        data: Object,
    },
    methods: {
        async markAllRead() {
            try {
                await axios.put(this.route("dashboard.readAllNotifications"), {
                    userId : this.$page.props.auth.user.id
                });
            } catch (error) {}

            await axios.get(route("notifications")).then((res) => {
                this.$page.props.auth.user.notifications = res.data?.notifications;
            })
        }
    }
}
</script>
<style scoped>
    .noscroll::-webkit-scrollbar {
        display: none; /* Hide scrollbar for Chrome, Safari and Opera */
    }
    .noscroll {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
</style>
